import { render, staticRenderFns } from "./AccountBox.vue?vue&type=template&id=0fd15757"
import script from "./AccountBox.vue?vue&type=script&lang=js"
export * from "./AccountBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd15757')) {
      api.createRecord('0fd15757', component.options)
    } else {
      api.reload('0fd15757', component.options)
    }
    module.hot.accept("./AccountBox.vue?vue&type=template&id=0fd15757", function () {
      api.rerender('0fd15757', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/accounts/AccountBox.vue"
export default component.exports